import { AudioService } from './audio.service';
import { googleMapsApiConfigProvider } from './google-maps-api-config.provider';
import { SocketService } from '@tablesready/frontend-store';

export * from './audio.service';
export * from './google-maps-api-config.provider';

export const PROVIDERS = [
  AudioService,
  SocketService,
  googleMapsApiConfigProvider,
];
